import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { BillingAccessGuard } from 'modules/billing/components/BillingAccessGuard';
import { PageWithBillingTabs } from 'modules/common/components/PageWithBillingTabs';
import { homeRoutesConfig } from 'domains/home/routes';

const BillingPage = loadable(
  async () => {
    const module = await import('./BillingPage');

    return module.BillingPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);
const homePath = homeRoutesConfig.home.generatePath();

export const BillingPageContainer = () => {
  return (
    <PageWithBillingTabs>
      <BillingAccessGuard
        fallback={<Navigate to={homePath} replace />}
        premissionFallback={<OverlaySpinner />}
      >
        <BillingPage />
      </BillingAccessGuard>
    </PageWithBillingTabs>
  );
};
